(function () {
  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function parseTrustData(root) {
    var script = root.querySelector('[data-trust-indicators-json]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('Unable to parse trust indicators data', error);
      return null;
    }
  }

  function buildListMarkup(items) {
    if (!items || !items.length) {
      return '<div class="product-trust-indicators" hidden></div>';
    }

    var html = '<div class="product-trust-indicators">';

    items.forEach(function (item) {
      var icon = item && item.icon ? String(item.icon) : '';
      var text = item && item.text ? String(item.text) : '';
      var link = item && item.link ? String(item.link) : '';

      if (!icon && !text) return;

      html += '<div class="product-trust-indicators__item">';

      if (link) {
        html += '<a href="' + escapeHtml(link) + '" class="product-trust-indicators__link">';
      }

      if (icon) {
        html +=
          '<img src="' +
          escapeHtml(icon) +
          '" alt="' +
          escapeHtml(text) +
          '" class="product-trust-indicators__icon" loading="lazy" width="64" height="64">';
      }

      if (text) {
        html += '<h3 class="product-trust-indicators__title">' + escapeHtml(text) + '</h3>';
      }

      if (link) {
        html += '</a>';
      }

      html += '</div>';
    });

    html += '</div>';
    return html;
  }

  function updateRoot(root, variantId) {
    var data = parseTrustData(root);
    if (!data || data.source !== 'variant') return;

    var list = root.querySelector('[data-trust-indicators-list]');
    if (!list) return;

    var items = (data.variants && data.variants[String(variantId)]) || [];
    list.innerHTML = buildListMarkup(items);
  }

  function onVariantChange(event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !variant.id) return;

    var section = event.currentTarget;
    section.querySelectorAll('[data-trust-indicators][data-trust-source="variant"]').forEach(function (root) {
      updateRoot(root, variant.id);
    });
  }

  function init() {
    document.querySelectorAll('[data-section-type="product"]').forEach(function (section) {
      if (section.getAttribute('data-trust-indicators-bound') === 'true') return;
      section.setAttribute('data-trust-indicators-bound', 'true');
      section.addEventListener('variantChange', onVariantChange);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
